import React from "react";

const TextAreaType = (props) => {
  let className = "text-area-type form-group pt-6 pl-3";
  if (props.showInDocUpload) {
    className = "text-area-type form-group pt-3";
  }
  if (props.viewOnly) {
    className += " view-only row";
  }
  return (
    <div className={className}>
      <label
        className={[props.viewOnly ? "col-md-4 col-sm-6" : "bold",props.field.fieldLabel.length > 12 && props.viewOnly ? "hide-text" : ""].join(" ")}
        htmlFor={props.field.fieldId}
      >
        {props.field.fieldLabel}
        {props.field.fieldRequired && !props.viewOnly && "*"}
      </label>
      {
        props.viewOnly ? (
          <span className="col-md-8 col-sm-6 pl-0 pb-3 description">
            {!props.field.fieldValue ? "-" : props.field.fieldValue}
          </span>
        ) : (
          <textarea
            className={[
              "form-control",
              props.viewOnly ? "col-md-8 col-sm-6" : "",
            ].join(" ")}
            id={props.field.fieldId}
            value={
              props.viewOnly && !props.field.fieldValue
                ? "-"
                : props.field.fieldValue
            }
            onChange={props.fieldValueChangeHandler}
            maxLength="300"
            rows="2"
            placeholder={props.field.fieldPlaceHolder}
            style={{height:"80px"}}
          ></textarea>
        )
      }

      
    </div>
  );
};

export default TextAreaType;
